import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    DroppableContainer: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '-16px',
        width: '100%'
    },
    DraggableContentContainerList: {
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        '&:focus-visible': {
            outline: 'rgba(0, 92, 102, 0.50) auto 1px'
        }
    },
    DraggableContentContainerCard: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: '16px',
        '&:focus-visible': {
            outline: 'rgba(0, 92, 102, 0.50) auto 1px'
        }
    },
    CardHeaderSection: {
        display: 'flex',
        padding: '8px 16px',
        justifyContent: 'space-between'
    },
    CardHeaderText: {
        display: 'flex',
        flexDirection: 'column'
    },
    CardContent: {
        padding: '0px 16px'
    },
    CardActions: {
        padding: '8px 16px'
    },
    GripIcon: {
        color: '#00000061',
        fontSize: '16px'
    }
}));
//# sourceMappingURL=styles.js.map